/**
 * questions ->
 * label -> string = nome para o componente Btn
 * textColor -> string = cor da label/texto para o componente Btn
 * hideBtn -> string = prop para ocultar o botão do componente Btn
 * backgroundColorContent -> string = Cor de fundo o componente Btn
 * contentColor -> string = cor do contéudo do componente Accordion quando estiver aberto
 */

import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import { Link } from "react-router-dom"
import { useNavigate } from 'react-router-dom';
import Accordion from '../../components/Accordion/Accordion'
import Btn from '../Btn/Btn';
import './MainQuestions.css'


const MainQuestions = (props) => {

    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/questions.json`);
    const navigate = useNavigate()

    const { questions, labelBtn } = data
    const { textColor, hideBtn, backgroundColorContent, contentColor } = props

    return (
        <div className="container-main-questions">
            {
                questions.map((d, i) => (
                    <Accordion
                        key={i}
                        title={d.question}
                        backgroundColorContent={backgroundColorContent}
                        contentColor={contentColor}
                        paddingContent={'30px 25px'}
                        isOpenBoxShadow={true}
                    ><span>{d.response}{d.link ? <><Link to={d.link}> {d.textLink}</Link> {d.afterLink}</>: ''}</span></Accordion>
                ))
            }
            <div className="main-questions-btn">
                    <Btn className={`${hideBtn && 'd-none'}`}
                        label={labelBtn}
                        textColor={textColor} type={'link'}
                        _function={() => navigate(`${language === 'pt-br' ? '/frequently-asked' : ``}`)} />
            </div>
        </div>
    )
}

export default MainQuestions;